import React, { useCallback, useState } from 'react';

import { cssMap } from '@compiled/react';

import Button from '@atlaskit/button/new';
import { Box } from '@atlaskit/primitives/compiled';
import Textfield from '@atlaskit/textfield';
import Toggle from '@atlaskit/toggle';
import { token } from '@atlaskit/tokens';

import { overrideGate } from '../../../common/persistance';

const styles = cssMap({
	container: {
		display: 'grid',
		gridTemplateColumns: '1fr 70px 60px',
		columnGap: token('space.100'),
		alignItems: 'center',
	},
	toggleWrapper: {
		justifySelf: 'center',
	},
});

export const AddOverride = ({
	updateOverrides,
}: {
	updateOverrides: () => void;
}): React.JSX.Element => {
	const [name, setName] = useState<string>('');
	const [value, setValue] = useState<boolean>(true);
	const onAddClick = useCallback(() => {
		overrideGate(name.trim(), value);
		setValue(true);
		setName('');
		updateOverrides();
	}, [name, updateOverrides, value]);

	return (
		<Box xcss={styles.container}>
			<Textfield
				id="name-textfield"
				label="Name"
				placeholder={`your_gate_name`}
				onChange={(e) => setName(e.currentTarget.value)}
				value={name}
			/>

			<Box xcss={styles.toggleWrapper}>
				<Toggle id="gate-toggle" isChecked={value} onChange={(e) => setValue(e.target.checked)} />
			</Box>

			<Button onClick={onAddClick}>Add</Button>
		</Box>
	);
};
